import Component from '../Component';
import $ from '../../vendor/CustomJquery';

export default class DeleteButton extends Component {

  configure() {
    return super.configure();
  }

  initialize() {
    this.subscribeToEvents();
    return super.initialize();
  }

  subscribeToEvents() {
    $(document).on('click', '.is-delete-button', (event) => {
      return this.onClick(event);
    });
  }

  onClick(event) {

    let self = $(event.currentTarget),
        route = self.data('route');

    if (typeof route === 'undefined') {
      return false;
    }

    event.preventDefault();

    return this.App.UI.Dialog.confirm(
      this.App.Language.get('_.are_you_sure'),
      () => {

        return this.App.API.remove(route).then(function (response) {

          self.closest('tr').addClass('is-deleted').delay(600).queue(function(){
            $(this).remove().dequeue();
          });

        }).catch((error) => {

          return this.App.UI.Dialog.alert(
            this.App.Language.get('errors.internal_error')
          );

        });

    });

  }

}